import { useEffect } from 'react';

interface CanonicalTagProps {
    href: string;
}

export const CanonicalTag: React.FC<CanonicalTagProps> = ({ href }) => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = href;
        document.head.appendChild(link);

        return () => {
            if (document.head.contains(link)) {
                document.head.removeChild(link);
            }
        };
    }, [href]);

    return null;
};
